import styled from "styled-components";

export const HomeBanner = styled.img`
  width: 100%;
`;
